import { Temporal } from '@js-temporal/polyfill';
import { timeZoneSource } from '../../../types';

export const getTimezone = (timezoneSource?: timeZoneSource) => {
  switch (timezoneSource) {
    case 'utc':
      return 'UTC';
    case 'local':
    case 'provided':
    default:
      return Temporal.Now.timeZoneId();
  }
};
